<script>
  import { onMount } from "svelte";
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import { discountUnitLabel } from "@retailer/svelte/Shared/DealHelpers.js";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import { DealDescriptionEntity } from "@shared/services/event_tracking/entities";

  import * as _ from "lodash";
  import { DISCOUNT_AMOUNT_TYPES } from "@shared/types/Deals";

  export let cartProduct;
  export let discount;
  export let discount_id;
  export let futureDeal = false;
  export let showAdditionalRequirements = false;
  export let disableQTYText = false;
  export let useLegacyLayout = true;

  const { trackEvent } = EventTracking;

  let element;

  onMount(() => {
    const entity = new DealDescriptionEntity({ discount_id, discount_text: element.textContent });
    trackEvent("begin_to_render", [entity]);
  });
</script>

<span bind:this={element}>
  {#if discount.amount_type === DISCOUNT_AMOUNT_TYPES.TEXT}
    {discount.plain_text}
  {:else if discount.amount_type === DISCOUNT_AMOUNT_TYPES.QUANTITY_WITH_REQUIREMENTS && showAdditionalRequirements}
    {discount.case_count}
    {discountUnitLabel(discount, cartProduct.product)}
    deal may apply (-<FormatMoney input={discount.amount} />/{discountUnitLabel(
      discount,
      cartProduct.product,
    )})
  {:else}
    {discount.case_count}
    {#if useLegacyLayout}
      {_.capitalize(discountUnitLabel(discount, cartProduct.product))}
    {:else}
      {discountUnitLabel(discount, cartProduct.product)}
    {/if}
    {#if disableQTYText}
      deal
    {:else}
      QTY deal
    {/if}

    {#if futureDeal}
      available
    {:else if useLegacyLayout}
      applied
    {/if}

    {#if useLegacyLayout}
      &ndash; <FormatMoney input={discount.amount} /> off per {discountUnitLabel(
        discount,
        cartProduct.product,
      )}
    {:else}
      (-<FormatMoney input={discount.amount} />/{discountUnitLabel(discount, cartProduct.product)})
    {/if}
  {/if}
</span>
